import axios from 'axios';
import * as config from "./config";
import store from './reducers/store';


const instance = axios.create({
  baseURL: config.BASE_URL
});

const state = store.getState();
if (state.auth.id) {
  instance.defaults.headers.common['Authorization'] = "Bearer " + state.auth.id;
}
// else {
//   instance.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('accessToken');
// }

instance.interceptors.request.use((config) => {
  const state = store.getState();
  if (state.filter.estabelecimentoId) {
    config.params = {...config.params, estabelecimentoId: state.filter.estabelecimentoId * 1 }
  }
  return config
})

export default instance;
